import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout>
      <div className="mx-auto flex w-full flex-col items-center px-4 py-24 text-center md:px-6 md:py-32">
        <span className="font-heading text-7xl font-black text-primary-200 md:text-9xl">404</span>
        <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">这个页面走丢了</h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
          你访问的地址可能已经失效，或者内容被调整到了新的位置。可以回到首页，继续追踪今天的热点。
        </p>
        <p className="mt-2 text-xs text-foreground-400">{location.pathname}</p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            返回首页
          </Link>
          <Link
            to="/rankings"
            className="inline-flex items-center justify-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-semibold text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            查看热搜榜单
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}